(() => {
  const config = window.RZBundleImageMap;

  if (!config?.blockId || !config?.bars) return;

  const blockSelector = `.kaching-bundles__block[data-deal-block-id="${config.blockId}"]`;
  let framePending = false;

  const applyImages = () => {
    framePending = false;

    const block = document.querySelector(blockSelector);
    if (!block) return;

    Object.entries(config.bars).forEach(([barId, replacements]) => {
      const bar = block.querySelector(
        `.kaching-bundles__bar[data-deal-bar-id="${barId}"]`
      );

      if (!bar) return;

      const images = bar.querySelectorAll(
        'img.kaching-bundles__bundle-products__image'
      );

      replacements.forEach((replacement, index) => {
        const image = images[index];

        if (!image || !replacement?.src) return;

        if (image.getAttribute('src') !== replacement.src) {
          image.setAttribute('src', replacement.src);
        }

        if (image.hasAttribute('srcset')) {
          image.removeAttribute('srcset');
        }

        image.alt = replacement.alt || '';
        image.dataset.rzBundleImage = replacement.key || `${barId}-${index}`;
      });
    });
  };

  const scheduleApply = () => {
    if (framePending) return;

    framePending = true;
    window.requestAnimationFrame(applyImages);
  };

  const observer = new MutationObserver(scheduleApply);

  const startObserver = () => {
    const target = document.documentElement;

    if (!target || typeof target.nodeType !== 'number') return;

    observer.observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        startObserver();
        scheduleApply();
      },
      { once: true }
    );
  } else {
    startObserver();
    scheduleApply();
  }
})();
